export default __webpack_public_path__ + "static/media/matconst-600x600.1fd02b8f.jpg";